import PropTypes from "prop-types";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

// Constants
const SALES_POSITION = "Sales Associate";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		position = "",
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	const isSalesPosition = position === SALES_POSITION;
	const MIN_INPUT_VALUE = isSalesPosition ? 0.5 : 1;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Unit",
							min: MIN_INPUT_VALUE,
							max: 10000,
							decimals: isSalesPosition ? 1 : 0,
							decimalsEditable: isSalesPosition,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Unit",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					data: [
						{
							type: "Unit",
							min: MIN_INPUT_VALUE,
							max: 10000,
							decimals: isSalesPosition ? 1 : 0,
							decimalsEditable: isSalesPosition,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Unit",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
					readOnly,
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	position: PropTypes.string,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
